import { Box } from '@realsoftworks/decor'
import styled from 'styled-components'

const Marker = styled(Box)`
  position: absolute;
`

export default Marker
